// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EnTranscript from '../pages/dhu/EnTranscript';
import ArTranscript from '../pages/dhu/ArTranscript';

const DhuRoutes = () => {
  return (
    <Routes>
      <Route path="/transcript-en/:stdId" element={<EnTranscript />} />
     <Route path="/transcript-ar/:stdId" element={<ArTranscript />} />
      
    </Routes>
  );
};

export default DhuRoutes;
